
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clobe/finance",
      function () {
        return require("private-next-pages/clobe/finance/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/clobe/finance"])
      });
    }
  